import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
export const navItems = [{
  name: 'Herzlich willkommen',
  path: '/angelika_sturny'
}, {
  name: 'Psychotherapie',
  path: '/angelika_sturny/psychotherapie'
}, {
  name: 'Coaching',
  path: '/angelika_sturny/coaching'
}, {
  name: 'Paartherapie',
  path: '/angelika_sturny/paartherapie'
}, {
  name: 'Familientherapie',
  path: '/angelika_sturny/familientherapie'
}, {
  name: 'Kinder & Jugendliche',
  path: '/angelika_sturny/kinder-jugendliche'
}, {
  name: 'Profil',
  path: '/angelika_sturny/profil'
}, {
  name: 'Info',
  path: '/angelika_sturny/info',
  subItems: [{
    name: 'Terminbuchung',
    path: '/angelika_sturny/info#terminbuchung'
  }, {
    name: 'Konditionen',
    path: '/angelika_sturny/info#konditionen'
  }, {
    name: 'Anfahrt',
    path: '/angelika_sturny/info#anfahrt'
  }]
}];
export function AngelikaSturnNavItems({
  isMobile = false,
  closeMobileMenu = () => {}
}) {
  const location = useLocation();
  const currentPath = location.pathname;
  const [hoveredItem, setHoveredItem] = useState<string | null>(null);
  return navItems.map(item => <li key={item.path} className={isMobile ? '' : 'relative'} onMouseEnter={() => !isMobile && setHoveredItem(item.path)} onMouseLeave={() => !isMobile && setHoveredItem(null)} data-id="element-82">
      <Link to={item.path} className={`
          ${isMobile ? 'block py-2 text-base' : 'whitespace-nowrap text-sm lg:text-sm py-2'}
          ${currentPath === item.path ? 'text-[#cda8be] font-semibold' : 'text-gray-600 hover:text-[#cda8be]'} transition-colors
        `} onClick={isMobile ? closeMobileMenu : undefined} data-id="element-83">
        {item.name}
      </Link>
      {/* Dropdown Menu für Desktop */}
      {!isMobile && item.subItems && hoveredItem === item.path && <div className="absolute right-0 top-full pt-2 z-[100]" data-id="element-84">
          <div className="bg-white shadow-lg rounded-md py-2 min-w-[180px] border border-gray-100" data-id="element-85">
            {item.subItems.map(subItem => <Link key={subItem.path} to={subItem.path} className="block px-4 py-2 text-sm text-gray-600 hover:bg-gray-50 hover:text-[#cda8be] transition-colors" data-id="element-86">
                {subItem.name}
              </Link>)}
          </div>
        </div>}
      {/* Subitems für Mobile */}
      {isMobile && item.subItems && <ul className="ml-4 mt-2 space-y-2" data-id="element-87">
          {item.subItems.map(subItem => <li key={subItem.path} data-id="element-88">
              <Link to={subItem.path} className="block py-1 text-sm text-gray-600 hover:text-[#cda8be] transition-colors" onClick={closeMobileMenu} data-id="element-89">
                {subItem.name}
              </Link>
            </li>)}
        </ul>}
    </li>);
}
export function AngelikaSturnNav() {
  return null;
}